import {
  UPDATE_VALIDATE_WINCH,
  UPDATE_VALIDATE_ROTATION_DIRECTION,
  UPDATE_VALIDATE_MOTOR_LAYOUT,
  UPDATE_VALIDATE_PAINT_FINISH,
  UPDATE_VALIDATE_MOTOR_TYPE
} from "../actions";

export const validWinch = (state = "", { type, payload }) => {
  switch (type) {
    case UPDATE_VALIDATE_WINCH:
      return payload.valid;
    default:
      return state;
  }
};

export const validMotorType = (state = "", { type, payload }) => {
  switch (type) {
    case UPDATE_VALIDATE_MOTOR_TYPE:
      return payload.valid;
    default:
      return state;
  }
};

export const validMotorLayout = (state = "", { type, payload }) => {
  switch (type) {
    case UPDATE_VALIDATE_MOTOR_LAYOUT:
      return payload.valid;
    default:
      return state;
  }
};

export const validRot = (state = "", { type, payload }) => {
  switch (type) {
    case UPDATE_VALIDATE_ROTATION_DIRECTION:
      return payload.valid;
    default:
      return state;
  }
};

export const validPaint = (state = "", { type, payload }) => {
  switch (type) {
    case UPDATE_VALIDATE_PAINT_FINISH:
      return payload.valid;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/validations.js